import { debugBus } from './debugBus';

interface Span { name: string; start: number; detail?: any }
const active = new Map<string, Span>();

function key(name: string, id?: string) { return id ? `${name}::${id}` : name; }

export function startSpan(name: string, detail?: any, id?: string) {
  const k = key(name, id);
  active.set(k, { name, start: performance.now(), detail });
}

export function endSpan(name: string, extra?: any, id?: string) {
  const k = key(name, id);
  const span = active.get(k);
  if (!span) return;
  active.delete(k);
  const dur = performance.now() - span.start;
  try { debugBus.push({ channel: 'perf', message: `${span.name}`, phase: 'end', detail: { duration_ms: +dur.toFixed(2), ...(span.detail||{}), ...(extra||{}) } }); } catch {}
}

export function withSpan<T>(name: string, fn: () => Promise<T> | T, detail?: any, id?: string): Promise<T> | T {
  const k = key(name, id); startSpan(name, detail, id);
  try {
    const ret = fn();
    if (ret && typeof (ret as any).then === 'function') {
      return (ret as Promise<T>).then(r => { endSpan(name, undefined, id); return r; }).catch(e => { endSpan(name, { error: e?.message || String(e) }, id); throw e; });
    }
    endSpan(name, undefined, id);
    return ret;
  } catch(e) { endSpan(name, { error: (e as any)?.message || String(e) }, id); throw e; }
}

// Install global PerformanceObserver hooks (LCP/FCP optional if supported)
export function installPerfObservers() {
  if (typeof window === 'undefined' || !(window as any).PerformanceObserver) return;
  try {
    const PO = (window as any).PerformanceObserver;
    const paintObserver = new PO((list: any) => {
      list.getEntries().forEach((entry: any) => {
        if (entry.name === 'first-contentful-paint') {
          debugBus.push({ channel: 'perf', message: 'FCP', detail: { time_ms: +entry.startTime.toFixed(2) } });
        }
      });
    });
    try { paintObserver.observe({ type: 'paint', buffered: true }); } catch {}
  } catch { /* noop */ }
  try {
    const PO = (window as any).PerformanceObserver;
    let longTaskCount = 0;
    const longTaskObserver = new PO((list: any) => {
      list.getEntries().forEach((entry: any) => {
        const durationMs = +entry.duration.toFixed(2);
        longTaskCount += 1;
        // Throttle: only log long tasks >= 50ms or every 5th task to avoid floods; never log huge objects
        const shouldLog = durationMs >= 50 || longTaskCount % 5 === 0;
        if (shouldLog) {
          debugBus.push({ channel: 'perf', message: 'long-task', detail: { duration_ms: durationMs } });
        }
      });
    });
    try { longTaskObserver.observe({ type: 'longtask', buffered: true }); } catch {}
  } catch { /* noop */ }
}

export type { Span };